/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const r=(()=>{const r=new ArrayBuffer(4),n=new Uint8Array(r);return new Uint32Array(r)[0]=1,1===n[0]})();export{r as isPlatformLittleEndian};
